import { Injectable } from 'angular-ts-decorators';

import type { LocalStorage } from '@shared/app/scripts/services/local-storage';

/**
 * Service for writing & reading state from local storing
 */
@Injectable('statePersistence')
export class StatePersistence {
  constructor(private localStorage: LocalStorage) {
    'ngInject';
  }

  /**
   * Method to read starte from memory
   * @param {string} key
   * Key that indentify the values
   * @param {any} defaultValue
   * Object to be returned if nothing found in memory
   * @return {any}
   * Value read from memory, or default
   */
  getState(key: string, defaultValue: any): any {
    const value = this.localStorage.getItem(key);

    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        // ignore parsing error
      }
    }

    return defaultValue;
  }

  /**
   * Sets state in memory
   * @param {string} key
   * Key that indentify the values
   * @param {any} newValue
   * value to be stored
   * @return {void}
   * Nothing
   */
  setState(key: string, newValue: any): void {
    this.localStorage.setItem(key, JSON.stringify(newValue));
  }
}
